import { useEffect, useState } from 'react';

import { useOrganisationsContext } from '@/context/OrganisationsContext';
import { useSubscriptionContext } from '@/context/SubscriptionContext';
import {
    addSubscriptionExpiredModalShown,
    getSubscriptionExpiredModalShown,
    removeSubscriptionExpiredModalShown,
} from '@/services/webStorage/localStorage/subscription';

import { useIsPremiumFeatureEnabled } from './useIsPremiumFeatureEnabled';

export const useShowSubscriptionExpiredModal = () => {
    const { currentOrganisationSubscription, isCurrentSubscriptionActive } =
        useSubscriptionContext();
    const { userOrganisation } = useOrganisationsContext();
    const { isPremiumFeatureEnabled } = useIsPremiumFeatureEnabled();
    const [showSubscriptionExpiredModal, setShowSubscriptionExpiredModal] =
        useState(false);

    const closeSubscriptionExpiredModal = () => {
        setShowSubscriptionExpiredModal(false);
    };

    useEffect(() => {
        if (!isPremiumFeatureEnabled) return;

        const organisation_id =
            currentOrganisationSubscription?.organisation_id;

        if (!organisation_id) return;

        const isTeamOwner = userOrganisation?.owner;

        if (isCurrentSubscriptionActive) {
            removeSubscriptionExpiredModalShown(
                currentOrganisationSubscription.organisation_id,
            );
            return;
        }

        if (!isTeamOwner) return;

        const hasShownModal = getSubscriptionExpiredModalShown(
            currentOrganisationSubscription.organisation_id,
        );

        if (!hasShownModal) {
            setShowSubscriptionExpiredModal(true);
            addSubscriptionExpiredModalShown(
                currentOrganisationSubscription.organisation_id,
                true,
            );
        }
    }, [
        currentOrganisationSubscription?.organisation_id,
        userOrganisation,
        isCurrentSubscriptionActive,
        isPremiumFeatureEnabled,
    ]);

    return { showSubscriptionExpiredModal, closeSubscriptionExpiredModal };
};
